const errorMessages = {
  6021524133446845: {email: 'Email address exist'},
  2521528291824284: {email: 'Account is not active'},
  9911524665223804: {email: 'Email not found'},
  4201524665228516: {password: 'Password is not valid'},
  40301:            {notAuthorised: 'You are not authorized User'},
  // Create Tour
  8341525244805345: {server: 'Error minPersons is more than maxPersons'},
  // Edit Profile
  1791526477613811: {checkPassword: 'Password is not valid'},
  8571526545800422: {newEmail: 'This email is busy'},
  // Edit Email
  6861526477703549: {currentPassword: 'Invalid current password'},
  // Delete Account
  6861526477703500: {currentPasswordDelAccount: 'Invalid current password'},
  7661536074587943: {resetPasswordWrongHash: 'This link is not valid. Try sending a password recovery request again.'}
};

const apiError = (err, dispatch, type) => {
  if (dispatch && typeof dispatch === 'function') {
    if (err && err.error && err.error.errorCode && errorMessages[err.error.errorCode]) {
      dispatch({type, data: errorMessages[err.error.errorCode]});
    } else {
      dispatch({type});
    }
  }
  console.error(`${type} ===>`, err);
  return err;
};

const error = (err, dispatch, type) => {
  if (dispatch && typeof dispatch === 'function')
    dispatch({type});
  console.error(`${type} ===>`, err);
  return err;
};

export {apiError, error}


// WEBPACK FOOTER //
// ./src/app/utils/request/errors.js